import { useEffect, useRef, useState } from "react"
import MonApi from "../state/mongo-api"
import Utils from "../util/Utils"
import { taskStore } from "../mytasks/task-store"
import { configStore } from "../state/CommonState"
import { useSnapshot } from "valtio"
import { Typography } from "@mui/material"
import { DocumentViewer } from "../pages/DocumentViewer"

export function DocumentCenter(props) {
   
    useSnapshot(taskStore)
    useSnapshot(configStore)
    const [fileList, setFileList] = useState([]);
    const [resultList, setResultList] = useState([]);
    const [ciList, setCiList] = useState([]);
    const [pkList, setPkList] = useState([]);
    const [openDocumentViewer,setDocumentViewerOpen] = useState(false);
    const documentRef = useRef();
    let task = taskStore.current
    let stage = task.stage
    let docs = task.files
    if (!docs) docs = {}
    console.log('*************', task)
    let server = process.env.REACT_APP_FILE_SERVER
    let dsrRec = props.dsrRec
    let staticDownloadUrl = `${server}/api/v1/filestore/staticfiles/`;

    let labelName = {
        commercialInvoiceList:'CI Upload',
        packingList:'PL Upload',
        carrierReleaseOrderList:'CRO',
        awbDraftList:'Draft AWB',
        blDraftList:'Draft BL',
        customsTaxesDutiesList:'CUSTOM DUTIES & TAXES',
        deliveryOrderList:'DO',
        finalAWBList:'Final AWB',
        finalBlList:'Final BL',
        freightInvoiceList:'FRIEGHT INVOICE',
        localChargesInvoiceList:'LOCAL CHARGES INVOICE',
        measurementSlipList:'MM COPY',
        podList:'POD',
        shippingInstructionList:'Shipping Instructions'
    }

    const handleDocumentViewer = (documentTitle,documentUrl,serverUrl)=>{
         documentRef.current = {documentTitle,documentUrl,serverUrl};
         setDocumentViewerOpen(true);
    }

    const onClose = ()=>{
        setDocumentViewerOpen(false);
        documentRef.current = null;
    }

    useEffect(() => {
        let f = async () => {
            let ret = await MonApi.find('Filestore', { '_id.pkey': props.dsrRec._id }, { 'content': 0 })
            let actions = await MonApi.find('Myactions', { bookingNum: props.dsrRec._id })
            let files = []
            for (let i = 0; i < actions.length; i++) {
                let a = actions[i]
                if(a.actionName.indexOf('Commercial Invoice & Packing List Pending')>=0){
                    let ci = []
                    let pk = []
                    if(dsrRec.booking.commercialInvoice_filename_list?.length > 0){
                        dsrRec.booking.commercialInvoice_filename_list?.map((e1)=>{
                            let k = false
                            let ap = false
                            if(a.files!=undefined){
                                a.files.map(e => {
                                    if(e.filename==e1){
                                        if (a.status === 'COMPLETED') {
                                            if(a.files!=undefined){
                                                a.files.map(e => (e.filename.length > 0) ? ap=true : 1)
                                            }
                                        }else if (a.customerStatus === 'COMPLETED') {
                                            if(a.files!=undefined){
                                                a.files.map(e => (e.filename.length > 0 && e.approved === 'Approve') ? ap=true : 1)
                                            }
                                        }
                                        k = true
                                    }
                                })
                            }
                            if(!k || (k && ap)){
                                ci.push(e1)
                            }
                        })
                    }
                    if(dsrRec.booking.packingList_filename_list?.length > 0){
                        dsrRec.booking.packingList_filename_list?.map((e1)=>{
                            let k = false
                            let ap = false
                            if(a.files!=undefined){
                                a.files.map(e => {
                                    if(e.filename==e1){
                                        if (a.status === 'COMPLETED') {
                                            if(a.files!=undefined){
                                                a.files.map(e => (e.filename.length > 0) ? ap=true : 1)
                                            }
                                        }else if (a.customerStatus === 'COMPLETED') {
                                            if(a.files!=undefined){
                                                a.files.map(e => (e.filename.length > 0 && e.approved === 'Approve') ? ap=true : 1)
                                            }
                                        }
                                        k = true
                                    }
                                })
                            }
                            if(!k || (k && ap)){
                                pk.push(e1)
                            }
                        })
                    }
                    if(JSON.stringify(ci)!=JSON.stringify(ciList)){
                        setCiList(ci)
                    }
                    if(JSON.stringify(pk)!=JSON.stringify(pkList)){
                        setPkList(pk)
                    }
                }
            }
            for (let i = 0; i < actions.length; i++) {
                let a = actions[i]
                if(a.actionName.indexOf('Additional Document Request')>=0){
                    // if(a.customerStatus ==='COMPLETED'){
                        a.documentRequest.map(e => (e.uploadedDocument.length > 0&&e.status==='Approve'&&e?.documentCategory==='Booking') ? files.push(e.uploadedDocument) : 1)
                        ret.filter((e) => files.includes(e._id.filename) || e?.label === "template")
                    // }
                }
                if(a.actionName.indexOf('Shipping Instructions') == -1){                    
                    if (a.status === 'COMPLETED') {
                        if(a.files!=undefined){
                            a.files.map(e => (e.filename?.length > 0) ? files.push(e.filename) : 1)
                        }
                        continue
                    }
                    if (a.customerStatus === 'COMPLETED') {
                        if(a.files!=undefined){
                            a.files.map(e => (e.filename.length > 0 && e.approved === 'Approve') ? files.push(e.filename) : 1)
                        }
                    }
                }else{
                    if (a.status === 'COMPLETED') {
                        if(a.files!=undefined){
                            if(a.files.length > 1  && a.files[1]?.filename.length > 0){
                                files.push(a.files[1]?.filename)
                            }else{
                                 a.files.map(e => (e.filename.length > 0) ? files.push(e.filename) : 1)
                            }
                        }
                        continue
                    }
                    if (a.customerStatus === 'COMPLETED') {
                        if(a.files!=undefined){
                            if(a.files.length > 1  && a.files[1]?.filename.length > 0){
                                files.push(a.files[1].filename)
                            }else{
                                 a.files.map(e => (e.filename?.length > 0) ? files.push(e.filename) : 1)
                            }
                        }
                    }
                }
                
            }
            
            ret = ret.filter(e => files.indexOf(e._id.filename) >= 0)

            console.log('RESULT OF DOCUMNET CENTER ACTIONS=', ret)
            setFileList(ret)
        }
        f()
        let enterpriseUploads = ()=>{
           if(dsrRec.Entities.customer.crossBorder.salesVertical !=='MSME'){
                let result = Object.keys(labelName).reduce((acc, key) => {
                    acc[key] = dsrRec.booking[key]?dsrRec.booking[key]:[];
                    return acc;
                }, {});
                 const allPairs = Object?.entries(result)?.flatMap(([key, values]) =>{
                    if(values.length > 0){
                     return values
                     ?.filter(val => val !== '' && val !== null && val !== undefined)
                     ?.map(val => ({ key, val }))
                    }
                    return []
                 });
                 setResultList(allPairs)
           }   
        }
        enterpriseUploads()

    }, [])
    //return <h1>{props.dsrRec._id}</h1>
    return (
        <div>
            {props.dsrRec.booking.shippingBill_filename_list?.length === 0 && props.dsrRec.booking.cartingPhotos_filename_list?.length === 0 && props.dsrRec.booking.mmSlip_filename_list?.length === 0 && props.dsrRec.booking.commercialInvoice_filename_list?.length === 0 && props.dsrRec.booking.packingList_filename_list?.length === 0 && props.dsrRec.booking.specialInstructions_filename_list?.length === 0 && props.dsrRec.booking.msds_filename.length === 0 && props.dsrRec.booking.nondgdecl_filename.length === 0 && props.dsrRec.booking.dgdecl_filename.length === 0 && props.dsrRec.booking.iipcert_filename.length === 0 && fileList.length ===0 && resultList.length ===0 ? <Typography sx={{textAlign:"center", fontWeight:"bold", fontFamily:"Figtree"}}>No Documents Found </Typography> :
            <>
            <table className="table is-narrow is-small is-fullwidth">
                <thead>
                    <tr>
                        <th>Document Name</th>
                        <th>Created Date</th>
                        <th>Created By</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        (ciList?.length > 0) ?
                            <>
                                {
                                    ciList.map((e,i) => {
                                        return <tr>
                                            <td>
                                                <a onClick={()=>{
                                                    handleDocumentViewer(ciList[i],`${server}/clientfiles/${e}`,staticDownloadUrl+e)
                                                }}>Commercial Invoice{ciList.length>1 && `-${i+1}`}</a>
                                            </td>
                                            <td>
                                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                            </td>
                                            <td>
                                                {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                            </td>
                                        </tr>
                                    })
                                }
                            </>
                            :
                            <></>
                    }
                    {
                        (pkList?.length > 0) ?
                            <>
                                {
                                    pkList.map((e,i) => {
                                        return <tr>
                                            <td>
                                                <a onClick={()=>{
                                                     handleDocumentViewer(pkList[i],`${server}/clientfiles/${e}`,staticDownloadUrl+e)
                                                }}>Packing List{pkList.length>1 && `-${i+1}`}</a>
                                            </td>
                                            <td>
                                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                            </td>
                                            <td>
                                            {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                            </td>
                                        </tr>
                                    })
                                }
                            </>
                            :
                            <></>
                    }
                    {
                        (dsrRec.booking.specialInstructions_filename_list?.length > 0) ?
                            <>
                                {
                                    dsrRec.booking.specialInstructions_filename_list.map((e,i) => {
                                        return <tr>
                                            <td>
                                                <a onClick={()=>{
                                                     handleDocumentViewer(dsrRec.booking.specialInstructions_filename_list[i],`${server}/clientfiles/${e}`,staticDownloadUrl+e)
                                                }}>Special Instructions{dsrRec.booking.specialInstructions_filename_list.length>1 && `-${i+1}`}</a>
                                            </td>
                                            <td>
                                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                            </td>
                                            <td>
                                            {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                            </td>
                                        </tr>
                                    })
                                }
                            </>
                            :
                            <></>
                    }

                    {
                        (dsrRec.booking?.custbookingconf_filename_list?.length > 0) ?
                            <>
                                {
                                    dsrRec.booking.custbookingconf_filename_list.map((e,i) => {
                                        return <tr>
                                            <td>
                                                <a onClick={()=>{
                                                     handleDocumentViewer(dsrRec.booking.custbookingconf_filename_list[i],`${server}/clientfiles/${e}`,staticDownloadUrl+e)
                                                }}>Customer Booking Confirmation{dsrRec.booking.custbookingconf_filename_list.length>1 && `-${i+1}`}</a>
                                            </td>
                                            <td>
                                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                            </td>
                                            <td>
                                            {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                            </td>
                                        </tr>
                                    })
                                }
                            </>
                            :
                            <></>
                    }
                    {
                        (dsrRec.booking.msds_filename.length > 0) ?
                            <tr>
                                <td>
                                    <a  onClick={()=>{
                                                     handleDocumentViewer(dsrRec.booking.msds_filename,`${server}/clientfiles/${dsrRec.booking.msds_filename}`,staticDownloadUrl+dsrRec.booking.msds_filename)
                                                }} >MSDS</a>
                                </td>
                                <td>
                                    {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                </td>
                                <td>
                                {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                </td>
                            </tr>
                            : <></>
                    }
                    {
                        (dsrRec.booking.nondgdecl_filename.length > 0) ?
                            <tr>
                                <td>
                                    <a onClick={()=>{
                                                     handleDocumentViewer(dsrRec.booking.nondgdecl_filename,`${server}/clientfiles/${dsrRec.booking.nondgdecl_filename}`,staticDownloadUrl+dsrRec.booking.nondgdecl_filename)
                                                }} >Non-DG Declaration</a>
                                </td>
                                <td>
                                    {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                </td>
                                <td>
                                {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                </td>
                            </tr>
                            : <></>
                    }
                    {
                        (dsrRec.booking.dgdecl_filename.length > 0) ?
                            <tr>
                                <td>
                                    <a
                                    onClick={()=>{
                                        handleDocumentViewer(dsrRec.booking.dgdecl_filename,`${server}/clientfiles/${dsrRec.booking.dgdecl_filename}`,staticDownloadUrl+dsrRec.booking.dgdecl_filename)
                                   }}
                                    >DG Declaration</a>
                                </td>
                                <td>
                                    {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                </td>
                                <td>
                                {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                </td>
                            </tr>
                            : <></>
                    }
                    {
                        (dsrRec.booking.iipcert_filename.length > 0) ?
                            <tr>
                                <td>
                                    <a onClick={()=>{
                                        handleDocumentViewer(dsrRec.booking.iipcert_filename,`${server}/clientfiles/${dsrRec.booking.iipcert_filename}`,staticDownloadUrl+dsrRec.booking.iipcert_filename)
                                   }}>IIP Certificate</a>
                                </td>
                                <td>
                                    {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                </td>
                                <td>
                                {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                </td>
                            </tr>
                            : <></>
                    }
                    {
                        (dsrRec.booking.shippingBill_filename_list?.length > 0) ?
                            <>
                                {
                                    dsrRec.booking.shippingBill_filename_list.map((e,i) => {
                                        return <tr>
                                            <td>
                                                <a onClick={()=>{
                                                     handleDocumentViewer(dsrRec.booking.shippingBill_filename_list[i],`${server}/clientfiles/${e}`,staticDownloadUrl+e)
                                                }}>Shipping Bill{dsrRec.booking.shippingBill_filename_list.length>1 && `-${i+1}`}</a>
                                            </td>
                                            <td>
                                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                            </td>
                                            <td>
                                            {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                            </td>
                                        </tr>
                                    })
                                }
                            </>
                            :
                            <></>
                    }
                    {
                        (dsrRec.booking.cartingPhotos_filename_list?.length > 0) ?
                            <>
                                {
                                    dsrRec.booking.cartingPhotos_filename_list.map((e,i) => {
                                        return <tr>
                                            <td>
                                                <a onClick={()=>{
                                                     handleDocumentViewer(dsrRec.booking.cartingPhotos_filename_list[i],`${server}/clientfiles/${e}`,staticDownloadUrl+e)
                                                }}>Carting photos{dsrRec.booking.cartingPhotos_filename_list.length>1 && `-${i+1}`}</a>
                                            </td>
                                            <td>
                                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                            </td>
                                            <td>
                                            {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                            </td>
                                        </tr>
                                    })
                                }
                            </>
                            :
                            <></>
                    }
                    {
                        (dsrRec.booking.mmSlip_filename_list?.length > 0) ?
                            <>
                                {
                                    dsrRec.booking.mmSlip_filename_list.map((e,i) => {
                                        return <tr>
                                            <td>
                                                <a onClick={()=>{
                                                     handleDocumentViewer(dsrRec.booking.mmSlip_filename_list[i],`${server}/clientfiles/${e}`,staticDownloadUrl+e)
                                                }}>MM Slip{dsrRec.booking.mmSlip_filename_list.length>1 && `-${i+1}`}</a>
                                            </td>
                                            <td>
                                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}
                                            </td>
                                            <td>
                                            {(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}
                                            </td>
                                        </tr>
                                    })
                                }
                            </>
                            :
                            <></>
                    }

                    <tr>

                    </tr>
                    {
                        fileList.map(e => <tr>
                            <td >
                                <a
                                onClick={()=>{
                                    handleDocumentViewer(e._id.filename,`${server}/api/v1/filestore/getfile/${e._id.pkey}/${e._id.filename}`,`${server}/api/v1/filestore/download/${e._id.pkey}/${e._id.filename}`)
                               }}
                               >
                                    {e.label}
                                </a>
                            </td>
                            <td>{Utils.formatToDateTime(e.approvedOn ? e.approvedOn : e.createdOn)}</td>
                            <td>{e.createdBy}</td>
                        </tr>
                        )
                    }   



                    {
                        (dsrRec?.Entities?.customer?.crossBorder?.salesVertical != 'MSME')?<>
                        {resultList?.map(e => <tr>
                            <td >
                                <a
                                onClick={()=>{
                                        handleDocumentViewer(e?.val,`${server}/api/v1/filestore/getfile/${dsrRec.booking._id}/${e?.val}`,`${server}/api/v1/filestore/download/${dsrRec.booking._id}/${e.val}`)
                               }}>
                                    {labelName[e?.key]}
                                </a>
                            </td>
                            <td>
                                {Utils.formatToDateTime1(dsrRec.booking.bookingDate, '')}</td>
                            <td>{(dsrRec.booking.tsCreatedBy!=undefined && dsrRec.booking.tsCreatedBy.length>0)?dsrRec.booking.tsCreatedBy:dsrRec.booking.tsUpdatedBy}</td>
                        </tr>
                        )}
                        </>:<></>
                    }             
                </tbody>
            </table>
             {
                    dsrRec.booking.photos?.length > 0 && (
                        <>
                        <h1 style={{fontWeight:'bold'}}>Stuffing Photos</h1>
                        <div
                            style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4, 1fr)',
                            gap: '16px',
                            marginTop: '12px'
                            }}
                        >
                            {dsrRec.booking.photos.map((file, idx) => {
                            const fileName =
                                typeof file === 'string' ? file.split('/').pop() : file.name;

                            const url =
                                typeof file === 'string'
                                ? process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName
                                : URL.createObjectURL(file);

                            return (
                                <div
                                key={`${fileName}-${idx}`}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center'
                                }}
                                >
                                <img
                                    src={url}
                                    alt={fileName}
                                    style={{
                                    width: '50%',
                                    height: '75px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd'
                                    }}
                                />
                                <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                    fontWeight: 'bold',
                                    color: '#007bff',
                                    textDecoration: 'underline',
                                    marginTop: '6px',
                                    overflowWrap: 'anywhere'
                                    }}
                                >
                                    {fileName}
                                </a>
                                </div>
                            );
                            })}
                        </div>
                        </>
                    )
                    }
            <hr />
            </>
            }
            {/*<p>
                <span>
                    <button className="button is-danger"
                        onClick={async (e) => {
                            taskStore.myActionVisible = false
                        }}>Cancel</button>
                    <button style={{ float: 'right' }} className="button islink"
                        onClick={async (e) => {
                            let keys = Object.keys(taskStore.current.files)
                            let rejected = false
                            if (!keys || !keys.length) { } else {
                                for (let i = 0; i < keys.length; i++) {
                                    let key = keys[i]
                                    let f = taskStore.current.files[key]
                                    if (f.approved === 'Reject' && !f.rejectReason) {
                                        configStore.setModalMessage('Rejection reason is mandatory')
                                        return
                                    }
                                    if (f.approved === 'Reject') rejected = true
                                }
                                if (rejected) taskStore.current.stage = 1
                                else {
                                    taskStore.current.stage = 3
                                    taskStore.setComplete()
                                }
                                await Taskapi.updateTask(taskStore.current)
                                taskStore.myActionVisible = false
                            }
                        }}>Submit</button>
                </span>
                    </p>*/}
                   { openDocumentViewer && <DocumentViewer open={openDocumentViewer} {...documentRef.current} onClose={onClose} download={true} />}
                
        </div>
    )
}